"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.invalidateAccessToken = void 0;
exports.getJWT = getJWT;
exports.decodeJWT = decodeJWT;
var jwt_decode_1 = require("jwt-decode");
var constants_1 = require("./constants");
var localStorageHelper = __importStar(require("./helpers/localStorageHelper"));
var tokenExpirationHelper_1 = require("./helpers/tokenExpirationHelper");
Object.defineProperty(exports, "invalidateAccessToken", { enumerable: true, get: function () { return tokenExpirationHelper_1.invalidateAccessToken; } });
function fetchAccessToken() {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(constants_1.IDP_ACCESS_TOKEN_ENDPOINT, {
                        credentials: 'include',
                    }).then(function (res) { return res.json(); })];
                case 1:
                    response = _a.sent();
                    if (!response || !response.access_token) {
                        throw new Error('Could not retrieve access token');
                    }
                    return [2 /*return*/, {
                            jwt: response.access_token,
                            expiryTimestamp: response.expires_in,
                        }];
            }
        });
    });
}
function getJWT() {
    return __awaiter(this, void 0, void 0, function () {
        var accessToken, hasValidToken, maxTries, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    accessToken = localStorageHelper.loadAccessToken();
                    hasValidToken = (accessToken === null || accessToken === void 0 ? void 0 : accessToken.jwt) && !(0, tokenExpirationHelper_1.isExpired)(accessToken);
                    if (hasValidToken) {
                        return [2 /*return*/, accessToken.jwt];
                    }
                    if (!localStorageHelper.getIsAccessTokenLoading()) return [3 /*break*/, 4];
                    maxTries = 5;
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < maxTries && localStorageHelper.getIsAccessTokenLoading())) return [3 /*break*/, 4];
                    /* eslint-disable no-await-in-loop */
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 200); })];
                case 2:
                    /* eslint-disable no-await-in-loop */
                    _a.sent();
                    accessToken = localStorageHelper.loadAccessToken();
                    if ((accessToken === null || accessToken === void 0 ? void 0 : accessToken.jwt) && !(0, tokenExpirationHelper_1.isExpired)(accessToken)) {
                        return [2 /*return*/, accessToken.jwt];
                    }
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4:
                    // If we couldn't return when we have valid token OR in whileloop - set loadTime to now and fetch token from remote
                    localStorageHelper.setAccessTokenLastRequestTime(Date.now());
                    return [4 /*yield*/, fetchAccessToken()];
                case 5:
                    accessToken = _a.sent();
                    localStorageHelper.storeAccessToken(accessToken);
                    (0, tokenExpirationHelper_1.setExpiryTimeout)(accessToken);
                    return [2 /*return*/, accessToken.jwt];
            }
        });
    });
}
function decodeJWT(jwt) {
    return (0, jwt_decode_1.jwtDecode)(jwt);
}
window.addEventListener('beforeunload', tokenExpirationHelper_1.invalidateAccessToken);
//# sourceMappingURL=AccessToken.js.map